import { FootnoteProps } from './footnote-model';
import styles from './footnote.module.scss';

export const Footnote: React.FC<FootnoteProps> = ({ heading, body }) => {
  return (
    <section className={styles.footnote}>
      <h2 className={styles.heading}>{heading}</h2>
      <article className={`${styles.body} richtext`}>{body}</article>
    </section>
  );
};
